import Vue from "vue";
import FormBuilderModel from "../../../../../common/models/tracked/formBuilderModel";
import Guid from "~/helpers/guid";
import {PermitteeType} from "~/enums/permitteeType";
import WorkflowStep from "../workflowStep";
import {TagColor} from "~/enums/tagColor";
import ThirdPartyCompleter from "../../formElements/templates/thirdPartyCompleter";
import {userActivationStatusDisplay} from "~/deactivatable";
import PermitteeAble from '~/mixins/permitteeAble';

export default abstract class WorkflowStepPermittee extends PermitteeAble(FormBuilderModel) {
  client_id: string = Guid.create();
  reference_id: string = null;
  reference_type: number = PermitteeType.originalSubmitter;
  [key: string]: any;
  except = ['form', 'createEmbeddedObject', 'first_name', 'last_name', 'name', 'activation_status'];

  constructor(workflowStep: WorkflowStep, json: any = {}) {
    super();
    this.defineProperty('client_id', json['client_id'] || Guid.create());
    this.defineProperty('reference_id', json['reference_id'] || null);
    this.defineProperty('reference_type', json['reference_type'] || PermitteeType.originalSubmitter);
    this.setDefaultDisplay();
    this.loadFromJson(json, workflowStep.rootModel);
    this.rootModel = workflowStep.rootModel;
    this.parent = workflowStep;
    this.setInDictionary();
  }

  update(props) {
    Object.getOwnPropertyNames(props).forEach(key => {
      this[key] = props[key];
    });
  }

  setInDictionary() {
    Vue.set(this.parent[this.rootName], this.client_id, this);
  }

  abstract get rootName(): string

  get isCollectionRoot(): boolean {
    return true;
  }

  get tagColor(): string {
    return TagColor[this.reference_type];
  }

  get display() {
    return this._display();
  }

  set display(funcOrString: Function | string) {
    if (typeof funcOrString === 'string') {
      this._display = () => funcOrString;
    } else {
      this._display = () => funcOrString(this);
    }
  }

  setDefaultDisplay() {
    switch (this.reference_type) {
      case PermitteeType.originalSubmitter:
        this.display = 'Original Submitter';
        break;
      case PermitteeType.allApprovers:
        this.display = 'All Approvers';
        break;
      case PermitteeType.allCompleters:
        this.display = 'All Completers';
        break;
      case PermitteeType.stepCompleters:
        this.display = 'Current Step Completers';
        break;
      case PermitteeType.group:
        // using String so undefined turns into "undefined"
        this.display = () => String(this.name);
        break;
      case PermitteeType.user:
        this.display = () => `${userActivationStatusDisplay(this)}`;
        break;
      case PermitteeType.thirdParty:
        this.display = () => this.thirdPartyViewer?.referenceNameOrDefault || "Deleted Third Party Step";
        break;
      case PermitteeType.lookupField:
        this.display = () => this.lookupFieldViewer?.referenceNameOrDefault || "Deleted Lookup Field Step"
    }
  }

  get thirdPartyViewer(): ThirdPartyCompleter {
    return this.parent.referenceableThirdPartyElements.find(tp => tp.client_id === this.reference_id);
  }

  get lookupFieldViewer() {
    return this.parent.referenceableLookupObjectModelFields.find(lf => lf.client_id === this.reference_id);
  }
}
